// bearer:disable javascript_lang_dangerous_insert_html
class DynamicModal {
  static closeButton = `<button class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>`;

  static openModal(content_or_url, url = false, options = {}) {
    const template = document.getElementById("dynamic-modal-template");
    const modal = template.content.cloneNode(true).children[0];

    document.body.appendChild(modal);
    bootstrap.Modal.getOrCreateInstance(modal).show();
    this.setDefaultContent(modal, options);

    if (url) {
      this.fetchAndSetContent(modal, content_or_url);
    } else {
      this.setContent(modal, content_or_url);
      this.addEventListeners(modal);
    }

    return modal
  }

  static setContent(modal, content) {
    if (content.includes("modal-title")) {
      modal.querySelector(".modal-content").innerHTML = content;
      modal.querySelector(".modal-header").insertAdjacentHTML('beforeend', this.closeButton);
    } else {
      let bodyElement = modal.querySelector(".modal-body");
      bodyElement.innerHTML = content;
    }
  }

  static addEventListeners(modal) {
    for (let closeTrigger of ["input[type='submit']", "button[type='submit']"]) {
      modal.querySelectorAll(closeTrigger).forEach((trigger) => {
        trigger.addEventListener('click', () => {
          bootstrap.Modal.getOrCreateInstance(modal).hide();
        });
      });
    }

    modal.addEventListener("hidden.bs.modal", () => {
      this.remove(modal);
    });
  }

  static setDefaultContent(modal, options) {
    if (options.default_title != null) {
      modal.querySelector(".modal-title").innerHTML = options.default_title;
    }
    if (options.default_body != null) {
      modal.querySelector(".modal-body").innerHTML = options.default_body;
    }
  }

  static fetchAndSetContent(modal, content_url) {
    fetch(content_url, {
        // We use this header to detect if we render the layout of the
        // requested view. For modal content we don't want to render the layout.
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
      })
      .then(response => {
        if (!response.ok) {
          throw response;
        }
        return response.text();
      })
      .then(content => {
        this.setContent(modal, content);
        this.addEventListeners(modal);
      })
      .catch((error) => {
        if (error instanceof Response) {
          let errorMessage = `Fetching ${content_url} failed with status ${error.status}: ${error.statusText}`;
          console.error('Error:', errorMessage);
        } else {
          console.error('Error:', error);
          Bugsnag.notify(error);
        }

        this.showError(modal);
      });
  }

  static remove(modal) {
    // dispatch removal to perform later so form submits can complete
    setTimeout(() => {
      bootstrap.Modal.getOrCreateInstance(modal).dispose(); // destroy boostrap modal instance
      modal.remove(); // remove modal from DOM
    }, 1);
  }

  static showError(modal) {
    this.setContent(modal, modal.dataset.errorMessage);
  }
}

module.exports = DynamicModal
